import {AssemblySearchRequest} from "../ImpellerAssemblyService";
import {convertAssemblyCriteriaToExportFormat} from "./ExportedAssemblyCriteriaV1";
import React from "react";

export function AssemblyCriteriaDownloader(props: { criteria: AssemblySearchRequest }) {

    const exportCriteria = () => {
        const exportedCriteria = convertAssemblyCriteriaToExportFormat(props.criteria);
        const fileData = JSON.stringify(exportedCriteria, null, 2); // Pretty format with indentation
        const blob = new Blob([fileData], {type: "application/json"});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = 'CRIT_ASSE_WENTECH_' + (new Date().toLocaleString('pl').replace(' ', 'T')) + '.json'; // ISO date
        link.href = url;
        link.click();
    }

    return <button className={"btn btn-sm btn-outline btn-outline-primary"} onClick={exportCriteria}>
        <i className="fas fa-save"></i>
    </button>;

}